module.exports = __webpack_public_path__ + "assets/img/join2021_002.4d02895d.png";